"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 1.2.0
 */
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var DynamicCommunicationService = /** @class */ (function () {
    function DynamicCommunicationService() {
        this._quickFilterMap = new Map();
        this._portfolioPropertiesSubject = new Subject_1.Subject();
        this._quickFilterSubject = new ReplaySubject_1.ReplaySubject(1);
    }
    DynamicCommunicationService_1 = DynamicCommunicationService;
    DynamicCommunicationService.createInstance = function () {
        return DynamicCommunicationService_1.INSTANCE;
    };
    Object.defineProperty(DynamicCommunicationService.prototype, "portfolioPropertiesSubject", {
        get: function () {
            return this._portfolioPropertiesSubject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCommunicationService.prototype, "portfolioPropertiesObservable", {
        get: function () {
            return this._portfolioPropertiesSubject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicCommunicationService.prototype, "quickFilterObservable", {
        get: function () {
            return this._quickFilterSubject;
        },
        enumerable: true,
        configurable: true
    });
    DynamicCommunicationService.prototype.applyQuickFilter = function (key, filter) {
        this._quickFilterMap.set(key, filter);
        this._quickFilterSubject.next(this._quickFilterMap);
    };
    DynamicCommunicationService.INSTANCE = new DynamicCommunicationService_1();
    DynamicCommunicationService = DynamicCommunicationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], DynamicCommunicationService);
    return DynamicCommunicationService;
    var DynamicCommunicationService_1;
}());
exports.DynamicCommunicationService = DynamicCommunicationService;
//# sourceMappingURL=dynamic-communication.service.js.map